var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLithuania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "85.333 85.333 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.88889 0 0 1.2143 9.4814 -18.286)",
    strokeWidth: 0.046508
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 85.333,
    width: 27,
    height: 14,
    fill: "#6da544"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 85.333,
    width: 27,
    height: 4.6667,
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 94.666,
    width: 27,
    height: 4.6667,
    fill: "#d80027"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLithuania);
export default __webpack_public_path__ + "static/media/lithuania.5658d7bf75d56cecb471ae773e231633.svg";
export { ForwardRef as ReactComponent };